import React from 'react'

export const SectionWrapper = ({
  children,
  id,
}: {
  children: React.ReactNode
  id: string
}) => {
  const hasRenderableChildren = React.Children.toArray(children).some(Boolean)
  if (!hasRenderableChildren) return null
  return (
    <div id={id} className="flex w-full flex-col gap-y-16">
      {children}
    </div>
  )
}
